import React from 'react'
import protecnus from './protecnus-logo.png';
import phone from './phone.png';
import Clientes from './Clientes';
import Contacto from './Contacto';

function Mantenimiento() {
  return (
    <div>
     <div className='contenedor-mantenimiento' >
     <h1 className='titulos'>Mantenimiento</h1>
    <p className='parrafos'>El mantenimiento preventivo de las instalaciones de calefacción y aire acondicionado consiste en las prestaciones de tareas programadas las cuales se efectúan con personal especializado permanente en el lugar, adecuándose a los horarios de funcionamiento de las instalaciones. 

El mismo servicio se hace extensivo a las especialidades eléctricas, sanitarias, redes de incendio, redes de agua potable, hidroneumáticos, cámaras frigoríficas, refrigeración, ventilación y a fines.</p>
    <img src={protecnus} width="40%" alt="" />
    <div className='contenedor-parrafo-protecnus'>
      <p className='parrafo-prote'>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non 

numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"

veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"</p>
      <img src={phone}  height="77%" alt="" />
    </div>
     </div>
    
    <Clientes/>
    <Contacto/>

    </div>
  )
}

export default Mantenimiento